import { livescoreHeaderTokens, oddsTokens, playoffTokens } from './general-components';

export const iceHockeyLivescoreTokens = {
  ...livescoreHeaderTokens,
  hiContrast: '',
  primaryBackgroundColor: '',
  rowBackgroundColor: '',
  oddsContainerPrimaryBgColor: '',
  pillBackgroundColor: '',
  pillActiveBackgroundColor: '',
  accentPrimaryBgColor: '',
  dropdownBorderColor: '',
  dropdownBtnColor: '',
  dropdownCalendarIconColor: '',
  dropdownArrowIconColor: '',
  oddItemHoverColor: '',
  oddsSelectionBackgroundColor: '',
  standingsLinkColor: '',
  scoreAccentColor: '',
};

export const iceHockeySingleEventTokens = {
  ...oddsTokens,
  hiContrast: '',
  sportEntityContainerPrimaryBgColor: '',
};

export const iceHockeyKnockoutStandingsTokens = {
  ...playoffTokens,
  hiContrast: '',
  primaryBackgroundColor: '',
  rowBackgroundColor: '',
  tableHeaderBG: '',
  tableBorderColor: '',
  tableRankHighlightColor: '',
  highLighted: '',
  pillBackgroundColor: '',
  dropdownBorderColor: '',
  dropdownBtnColor: '',
};
